// Util function to create customer DTO logo path
import { Customer } from "../models/customer.interface";
import { getLetterLogoDataUrl } from "./letter-logo.util";

import { Observable, catchError, map, of } from "rxjs";
import { getPrimaryColorObservable } from "./image-primary-colour.util";

import { CustomerFilter } from "@modules/global-dashboard/models/global-dashboard-interface";
import { CustomerInfoOnSideNav } from "@modules/config/_models/dashboard.model";

export const createCustomerLogoPath = (customer: Customer): Customer => {
	if (customer.logo && customer.logo.items.length > 0) {
		customer.imagePath = getLetterLogoDataUrl(customer.name);
	}

	return customer;
};

/**
 * When it's less important to show the latest image between page refreshes use a cached version.
 */
export const createCustomerLogoPathUseImgCache = (customer: Customer): Customer => {
	if (customer.logo && customer.logo.items.length > 0) {
		customer.imagePath = getLetterLogoDataUrl(customer.name);
	}

	return customer;
};

//For customerFilter Interface
export const createCustomerFilterLogoPath = (customer: CustomerFilter): CustomerFilter => {
	if (customer.logo && customer.logo.items.length > 0) {
		customer.imagePath = getLetterLogoDataUrl(customer.name);
	}

	return customer;
};

export const getCustomerLogoAndPrimaryColour = (customer: Customer): Observable<CustomerInfoOnSideNav> => {
	const image = createCustomerLogoPath(customer)?.imagePath;

	if (image) {
		return getPrimaryColorObservable(image).pipe(
			map(primaryColor => ({
				logo: image,
				primaryColour: primaryColor
			})),
			catchError(error => {
				console.error("Error occurred:", error);
				return of({
					logo: image,
					primaryColour: "var(--color-basic-100)"
				});
			})
		);
	} else {
		return of({
			logo: "",
			primaryColour: "var(--color-basic-100)"
		});
	}
};
